import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdlinkComponent } from './adlink.component';
import { DeleteComponent } from './modals/delete/delete.component';
import { CreateComponent } from './modals/create/create.component';
import { EditComponent } from './modals/edit/edit.component';
import { FormsModule } from '@angular/forms';
import { PaginationModule } from '../layout/pagination/pagination.module';

@NgModule({
  imports: [
    CommonModule,
    PaginationModule,
    FormsModule,
    AdlinkComponent,
    DeleteComponent,
    CreateComponent,
    EditComponent,
  ],
  exports: [AdlinkComponent],
})
export class AdlinkModule {}
